import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const DatePickerTheme = {
    datePicker: {
        light: {
            backgroundColor: Colors.white,
            borderColor: withOpacity(Colors.black, Opacities.xLow),
            dayNamesTextColor: withOpacity(Colors.black, Opacities.medium),
            dayStates: {
                default: {
                    textColor: Colors.black,
                    backgroundColor: Colors.white,
                },
                today: {
                    textColor: Colors.black,
                },
                disabled: {
                    textColor: withOpacity(Colors.black, Opacities.low),
                },
                hover: {
                    backgroundColor: withOpacity(Colors.greyChateau, Opacities.xLow),
                },
                active: {
                    backgroundColor: Colors.safetyOrange,
                    textColor: Colors.black,
                },
                inRange: {
                    backgroundColor: withOpacity(Colors.greyChateau, Opacities.xLow),
                },
            },
        },
        dark: {
            backgroundColor: Colors.black,
            borderColor: withOpacity(Colors.white, Opacities.xLow),
            dayNamesTextColor: withOpacity(Colors.white, Opacities.medium),
            dayStates: {
                default: {
                    textColor: Colors.white,
                    backgroundColor: Colors.black,
                },
                today: {
                    textColor: Colors.black,
                },
                disabled: {
                    textColor: withOpacity(Colors.white, Opacities.low),
                },
                hover: {
                    backgroundColor: withOpacity(Colors.agatheGrey, Opacities.xLow),
                },
                active: {
                    backgroundColor: Colors.safetyOrange,
                    textColor: Colors.black,
                },
                inRange: {
                    backgroundColor: withOpacity(Colors.greyChateau, Opacities.xLow),
                },
            },
        },
    },
};
export default DatePickerTheme;
